<template>
    <button
        class="bg-white dark:bg-stone-900 dark:hover:bg-stone-800 hover:bg-stone-200 text-stone-800 dark:text-stone-100 jacquard12 font-semibold text-xl py-2 px-4 border border-stone-400 rounded shadow"
        @click="navigate"
    >
        {{ label }}
    </button>
</template>

<script lang="js" setup>
import { defineProps } from 'vue'
import { useRouter } from 'vue-router'

const props = defineProps({
    action: String,
    label: String
})

const router = useRouter()

const navigate = () => {
    if (props.action) {
        router.push(props.action)
    } else {
        console.warn("Aucune action définie pour ce bouton.")
    }
}
</script>
